import { Pipe, PipeTransform } from '@angular/core';
import { Entity } from './entity';

@Pipe({
  standalone: true,
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform<T extends Entity, U extends Entity>(entities: T[], args: U[]): T[] {
    const ids = args.map((entity) => entity.id);
    return entities.filter((e) => ids.includes(e.id));
  }
}
